exports.filedRules = () => {
    return {
        required: (value) => !!value || `필수입력입니다.`, //${filed} is 
        counter: (value) => value && value.length >= 3 || `Please enter at least 3 characters`,
    }
};
exports.requiredRule = value => {
    return !!value || "Required.";
};
exports.ko_requiredRule = value => {
    return !!value || "필수 입력 정보입니다.";
};
exports.tagRules = () => {
    return {
        required: (value) => !!value || "태그를 입력해주세요.",
        counter: (value) => value && value.length <= 10 || "최대 10자로 입력해주세요",
    }
};
exports.eligibleRules = () => {
    return {
        required: (value) => !!value || "This is required",
        counter: (value) => value && value.length < 1 || "Please enter a value greater than at least 0",
    }
};
exports.declarationRules = () => {
    return {
        required: (value) => !!value || "신고사유를 입력해주세요.",
        counter: (value) => value && value.length > 5 || "최소 5자이상으로 입력해주세요",
    }
};
exports.SSNRules = () => {
    return {
        required: (value) => !!value || "SSN is Required",
        counter: (value) => value && value.length > 8 || "SSN must be 8 digits long",
        check: (value) => {
            const pattern = /^\d+$/;
            return pattern.test(value) || "Only numbers are allowed";
        },
    }
};
exports.idRules = () => {
    return {
        required: (value) => !!value || "로그인아이디는 필수입니다.",
        email: (value) => {
            const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "로그인아이디는 이메일 형식입니다.";
        },
    }
};
exports.emailRules = () => {
    return {
        required: (value) => !!value || "Email is Required",
        counter: (value) => value && value.length <= 100 || "Max 100 characters",
        email: (value) => {
            const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Please check if your Email is correct.";
        },
    }
};
exports.loginIdRules = () => {
    return {
        required: (value) => !!value || "아이디(휴대폰 번호)로 넣어주세요",
        email: (value) => {
            const pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "로그인아이디는 이메일 형식입니다.";
        },
    }
};

exports.loginPasswordRules = () => {
    return {
        required: (value) => !!value || "비밀번호를 입력해주세요",
        counter: (value) =>
            value && (value.length >= 6 && value.length <= 20) ||
            "6-20자리로 입력해 주세요",
        check: (value) => {
            let num = value.search(/[0-9]/g);
            let eng = value.search(/[a-z]/ig);
            let spe = value.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
            const pattern = (num < 0 && eng < 0) || (eng < 0 && spe < 0) || (spe < 0 && num < 0);
            // const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/;
            console.log(pattern);
            return !pattern ||
                "영문 대소문자, 특수문자, 숫자를 포함한 6~20자리로 입력해 주세요.";
        }
    }
};

exports.emailIdRules = () => {
    return {
        // check: (value) => {
        //     let num = value.search(/[0-9]/g);
        //     let eng = value.search(/[a-z]/ig);
        //     let spe = value.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
        //     const pattern = (num < 0 && eng < 0) || (eng < 0 && spe < 0) || (spe < 0 && num < 0);
        //     // const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/;
        //     console.log(pattern);
        //     return !pattern ||
        //         "영문 대소문자, 특수문자, 숫자를 포함한 6~20자리로 설정해 주세요.";
        // },
        check2: (value) => {
            const pattern = /^[a-zA-Z0-9!@#$%^&*?_.]+$/;
            // const pattern = /^[a-zA-Z0-9]*$/
            // /^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value); // || "영문 대소문자, 특수문자, 숫자로 입력해주세요";
        },
    }
};

exports.passwordRules = () => {
    return {
        required: (value) => !!value || "비밀번호는 필수입니다.",
        counter: (value) =>
            value && (value.length >= 6 && value.length <= 20) ||
            "6-20자리로 설정해 주세요",
        check: (value) => {
            let num = value.search(/[0-9]/g);
            let eng = value.search(/[a-z]/ig);
            let spe = value.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi);
            const pattern = (num < 0 && eng < 0) || (eng < 0 && spe < 0) || (spe < 0 && num < 0);
            // const pattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,16}$/;
            console.log(pattern);
            return !pattern ||
                "영문 대소문자, 특수문자, 숫자를 포함한 6~20자리로 설정해 주세요.";
        }
    }
};
exports.cellRules = () => {
    return {
        required: (value) => !!value || "휴대폰번호는 필수입력입니다.",
        counter: (value) => value && value.length > 8 && value.length < 12 || "올바른 휴대폰번호를 입력해주세요",
        min: (value) => value && value.length > 8 || "올바른 휴대폰번호를 입력해주세요",
        max: (value) => value && value.length < 12 || "올바른 휴대폰번호를 입력해주세요",
        check: (value) => {
            const pattern =
                /^(01[016789]{1})[0-9]{3,4}[0-9]{4}$/g;
            return pattern.test(value) || "올바른 휴대폰번호를 입력해주세요";
        },
    }
};
exports.nameRules = () => {
    let reData = {
        required: (value) => !!value || "이름을 입력해 주세요",
        counter: (value) => value && value.length >= 2 && value.length <= 10 || "이름은 2 글자 이상 10 글자 이하 이어야 합니다",
        check: (value) => {
            const pattern = /^[ㄱ-ㅎ가-힣]+$/;
            return pattern.test(value) || "이름에 특수기호와 숫자, 영문은 입력할 수 없습니다.";
        },
    }
    return reData;
};

exports.cropAreaRules = () => {
    return {
        min: (value) => value > 0 || "재배 면적은 1 미만으로 입력할 수 없습니다.",
        max: (value) => value < 1000000 || "재배 면적은 1000000 이상으로 입력할 수 없습니다.",
        check: (value) => {
            const pattern = /^[0-9]+$/;
            return pattern.test(value) || "숫자만 입력해주세요";
        },
    }
};

exports.nicknameRules = () => {
    let reData = {
        required: (value) => !!value || "닉네임 입력은 필수 입니다.",
        counter: (value) => value && value.length >= 2 && value.length <= 10 || "닉네임은 2 글자 이상 10 글자 이하 이어야 합니다",
    }
    return reData;
};
exports.birthdayRules = () => {
    let reData = {
        required: (value) => !!value || "DOB is required",
        check: (value) => {
            const pattern =
                /^(19[0-9][0-9]|20\d{2}|2100)(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/g;
            return pattern.test(value) || "Please check if birthday is correct.";
        },
    }
    return reData;
};
exports.birthtimeRules = () => {
    let reData = {
        counter: (value) => !value ||
            (!!value && value.length == 4) || "시간은 4자리수입니다.",
        check: (value) => {
            const pattern =
                /^(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])$/g;
            return pattern.test(value) || "00 ~ 23시, 00 ~ 59분으로 입력해주세요.";
        },
    }
    return reData;
};
exports.daysOfWeek = () => {
    let reData = ["일", "월", "화", "수", "목", "금", "토"];
    return reData;
};
exports.monthName = () => {
    let reData = [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월",
    ];
    return reData;
};
exports.s3Config = () => {
    let reData = {
        S3_BUCKET: 'zplabpublic',
        S3_REGION: 'ap-northeast-2',
        S3_POOLID: 'ap-northeast-2:cae44641-b6f1-4893-9615-3ef9523f732a',
        // S3_UPLOAD_ROOT: 'bayerFarm'
    }
    return reData;
};
exports.birthTime = () => {
    let reData = [
        { value: "", text: "모름" },
        { value: "2330", text: "자 (23:30 ~ 01:29)" },
        { value: "0130", text: "축 (01:30 ~ 03:29)" },
        { value: "0330", text: "인 (03:30 ~ 05:29)" },
        { value: "0530", text: "묘 (05:30 ~ 07:29)" },
        { value: "0730", text: "진 (07:30 ~ 09:29)" },
        { value: "0930", text: "사 (09:30 ~ 11:29)" },
        { value: "1130", text: "오 (11:30 ~ 13:29)" },
        { value: "1330", text: "미 (13:30 ~ 15:29)" },
        { value: "1530", text: "신 (15:30 ~ 17:29)" },
        { value: "1730", text: "유 (17:30 ~ 19:29)" },
        { value: "1930", text: "술 (19:30 ~ 21:29)" },
        { value: "2130", text: "해 (21:30 ~ 23:29)" },
    ];
    return reData;
};